export const PHASE = {
	PAINT: 0,
	AFTER_PAINT: 1,
	LAZY: 2,
};

export const COLLECTED = new Map();
